import { useWatch } from '../../../contexts';
import { useConditionFieldNameFieldPath } from '../fieldPaths/useConditionFieldNameFieldPath';

export const useConditionFieldNameWatch = () => {
  const fieldPath = useConditionFieldNameFieldPath();
  return useWatch({ name: fieldPath });
};
